import React from "react";
import { Navigate } from "react-router-dom";
import { PATH } from "../utils/pagePath";
import { LOCALSTORAGE } from "../utils/constants";
import { decryptData } from "../utils/encryption_decryption";
import { getData} from "../utils/storage";
import { FacilityType } from "../layouts/utils/type";


// ADDED BY ANAND 06-04-2026
const ProtectedRoute = ({ children, requiredRoles }: {
  children: React.ReactNode;
  requiredRoles?: string[];
}) => {
  const accessToken = getData(LOCALSTORAGE.ACCESS_TOKEN, true);
    const facilityData = getData<FacilityType>("FACILITYID", false)
   const roleTypeCode:string=facilityData?.ROLETYPECODE ?? "";
 
  if (!accessToken) {
    return <Navigate to={PATH.LOGIN} replace />;
  }
  if (requiredRoles && !requiredRoles.includes(roleTypeCode)) {
    return <Navigate to={PATH.PAGE_NOT_FOUND} replace />;
  }
  return <>{children}</>;
};

export default ProtectedRoute;